import config from "@Config";
import { AppContext, Events } from "@Context/common/general/context";
import { compareVersions } from "compare-versions";
import { useCallback, useContext, useEffect, useState } from "react";

export const usePlatformNotificationState = () => {
  const { state } = useContext(AppContext);
  const [isUpdateRequired, setIsUpdateRequired] = useState(false);
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(config.maintenanceModeEnabled);
  const [isServiceOutageMode, setIsServiceOutageMode] = useState(config.serviceOutageBlocker);

  const resolveClientVersion = useCallback(
    (clientVersion?: string) => {
      const platformConfig = config.platformConfigs[state.device.family as keyof typeof config.platformConfigs];
      const minimumVersion = platformConfig?.minimumClientVersion;

      if (!clientVersion || !minimumVersion) {
        return;
      }

      if (compareVersions(clientVersion, minimumVersion) === -1 && (state.device.isVR || state.device.isMobile)) {
        setIsUpdateRequired(true);
      }
    },
    [state.device.family, state.device.isMobile, state.device.isVR]
  );

  useEffect(() => {
    const platformConfig = config.platformConfigs[state.device.family as keyof typeof config.platformConfigs];

    if (state.app.bridgeInitialized) {
      setIsMaintenanceMode(Boolean(platformConfig?.maintenanceModeEnabled));
      setIsServiceOutageMode(Boolean(platformConfig?.serviceOutageBlocker));
      resolveClientVersion(state.app.clientVersion);

      return;
    }

    Events.app.gameReadyEvent.once((data: { client_version?: string } | undefined) => {
      resolveClientVersion(data?.client_version);
    });
  }, [resolveClientVersion, state.app.bridgeInitialized, state.app.clientVersion, state.device.family]);

  return {
    isMaintenanceMode,
    isServiceOutageMode,
    isUpdateRequired,
  };
};
